import React from 'react';
import { Award } from 'lucide-react';

const CertificatesPlaceholder = () => {
    return (
        <div className="col-span-1 md:col-span-2 flex flex-col items-center justify-center text-center p-12 bg-white rounded-xl border-2 border-dashed border-slate-200 h-full">
            <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center text-slate-400 mb-6">
                <Award size={40} />
            </div>
            <h3 className="text-xl font-bold text-slate-800 mb-2">Tus Certificaciones Aparecerán Aquí</h3>
            <p className="text-slate-500 max-w-md">
                Cuando finalices un curso y obtengas una certificación, la encontrarás en esta sección lista para descargar y compartir.
            </p>
        </div>
    );
};

export default CertificatesPlaceholder;
